/**
 * Cayman Islands dollar.
 */
export var KYD = {
  code: 'KYD',
  base: 10,
  exponent: 2
};